/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import { restructureTopUserModel } from './restructuring';

const getTopUsersDestruct = async (state, response) => {
  const responseJson = await response.json();
  if (!responseJson.success) {
    return {
      response: responseJson,
      destructData: null
    };
  }
  return {
    response: responseJson,
    destructData: {
      itemsById: _.keyBy(
        _.map(responseJson.data.items, item =>
          restructureTopUserModel(state, item)
        ),
        'id'
      ),
      itemsIds: _.map(responseJson.data.items, item => item.id)
    }
  };
};

class TopUsersService {
  async getTopUsersOfEarnings(state, queryParams) {
    const response = await api.get('/top-users/of-earnings', {
      expand: `profile`,
      ...queryParams
    });
    const destructData = await getTopUsersDestruct(state, response);
    return destructData;
  }
  async getTopUsersOfAdvertising(state, queryParams) {
    const response = await api.get('/top-users/of-advertising', {
      expand: `profile`,
      ...queryParams
    });
    const destructData = await getTopUsersDestruct(state, response);
    return destructData;
  }
  async getTopUsersOfExperience(state, queryParams) {
    const response = await api.get('/top-users/of-experience', {
      expand: `profile`,
      ...queryParams
    });
    const destructData = await getTopUsersDestruct(state, response);
    return destructData;
  }
  async getTopUsersOfReferrals(state, queryParams) {
    const response = await api.get('/top-users/of-referrals', {
      expand: `profile`,
      ...queryParams
    });
    const destructData = await getTopUsersDestruct(state, response);
    return destructData;
  }
}

export default new TopUsersService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/topUsers/services/TopUsersService/TopUsersService.js